
//
// Pure Helpers
//

function getPreviewIndexAndValuesFromFormData (entry) {
  var parts  = entry.name.split('items[')[1].split('][');
  return { ix: parseInt(parts[0]), name: parts[1].replace(']', ''), value: entry.value };
}

function ixMatch (targetIx) {
  return function _ixMatch (entry) {
    return entry.ix === targetIx;
  }
}


//
// Voucher Personalisation Page Controller
//

module.exports = function PersonliseController ($page, $$) {

  // Hook up voucher preview buttons with form data

  var modal = getWidgetAtDom($$('[data-modal="preview"]'));
  var $form = $$('form');

  $$('[data-voucher-preview-trigger]').on('click', function () {
    var $button  = $(this);
    var targetIx = $button.data('voucher-preview-trigger');
    var data     = {};

    $form.serializeArray()
      .map(getPreviewIndexAndValuesFromFormData)
      .filter(ixMatch(targetIx))
      .map(function (entry) { data[entry.name] = entry.value; });

    modal.invoke('PREVIEW', $.param(data));
  });

}

